import { Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-sts-credentials-panel',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './sts-credentials-panel.component.html',
  styleUrl: './sts-credentials-panel.component.scss',
  animations: [
    trigger('expandCollapse', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-4px)' }),
        animate(
          '160ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
      transition(':leave', [
        animate(
          '120ms ease-in',
          style({ opacity: 0, transform: 'translateY(-4px)' })
        ),
      ]),
    ]),
  ],
})
export class StsCredentialsPanelComponent {
  @Input() form!: FormGroup;
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() showStsPassword: boolean = false;
  @Input() showStsPin: boolean = false;
  @Input() isSaving: boolean = false;
  @Input() stsUsername: string | null = null;

  isPasswordEditing = false;
  isPinEditing = false;

  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() togglePasswordVisibility = new EventEmitter<void>();
  @Output() togglePinVisibility = new EventEmitter<void>();

  get isCreateMode(): boolean {
    return this.mode === 'create';
  }

  get isEditMode(): boolean {
    return this.mode === 'edit';
  }

  get title(): string {
    return this.isEditMode
      ? 'Modifica credenziali STS'
      : 'Configura credenziali STS';
  }

  get usernamePlaceholder(): string {
    return this.isEditMode
      ? 'Modifica username STS (opzionale)'
      : 'Inserisci username STS';
  }

  get passwordPlaceholder(): string {
    return this.isEditMode
      ? 'Inserisci nuova password STS'
      : 'Scegli una password STS';
  }

  get pinPlaceholder(): string {
    return this.isEditMode ? 'Inserisci nuovo PIN STS' : 'Scegli il PIN STS';
  }

  toggleEditPassword(): void {
    this.isPasswordEditing = !this.isPasswordEditing;
    if (this.isPasswordEditing) {
      // entering edit mode: start from an empty value so we never show the old secret
      this.form.get('sts_password')?.reset();
    } else {
      // leaving edit mode: clear the control so no update is sent
      this.form.get('sts_password')?.setValue(null);
    }
  }

  toggleEditPin(): void {
    this.isPinEditing = !this.isPinEditing;
    if (this.isPinEditing) {
      this.form.get('sts_pin')?.reset();
    } else {
      this.form.get('sts_pin')?.setValue(null);
    }
  }
}
